import * as React from 'react';

import type {FilterObject, EntityListType} from 'nutshell-core/types';
import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';
import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import styles from './entity-list-entity-count.module.css';

type Props = {
    entityType: EntityListType;
    entityCount: number; // The count of filtered rows,
    activeFilters: FilterObject[];
    isRefreshingFilters: boolean;
    currentSearch: string | null | undefined;
};

export class EntityListEntityCount extends React.PureComponent<Props> {
    render() {
        const isFilteringOrSearching = this.props.currentSearch || this.props.activeFilters.length;
        const entityDisplayName =
            this.props.entityCount === 1
                ? getSingularEntityType(this.props.entityType)
                : getMultipleEntityType(this.props.entityType);

        return (
            <div className={styles.container}>
                {this.props.isRefreshingFilters ? (
                    <span>Loading…</span>
                ) : (
                    <span>
                        {this.props.entityCount.toLocaleString()} {entityDisplayName}{' '}
                        {isFilteringOrSearching ? 'found' : ''}
                    </span>
                )}
            </div>
        );
    }
}
